// extracted by mini-css-extract-plugin
export default {"infoContainer":"style_infoContainer__Wp72A","titleAction":"style_titleAction__u1N1p","personnalData":"style_personnalData__uKE3w","fullname":"style_fullname__JR8k6"};